export function FocusDirective($timeout) {
  'ngInject';

  return {
    link: function (scope, element, attrs) {
      scope.$watch(attrs.setFocus, (value) => {
        if (value === true) {
          $timeout(element[0].focus());
        }
      });
    }
  };
}
